import { render, staticRenderFns } from "./DeckForm.vue?vue&type=template&id=63b2d1d4&"
import script from "./DeckForm.vue?vue&type=script&lang=js&"
export * from "./DeckForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports